import React from 'react';
import InputField from 'components/pure/utils/form/InputField';
import SelectField from 'components/pure/utils/form/SelectField';
import './NotificationThrottleEdit.styl';
import {throttleOptions} from 'components/triggers/trigger-actions/ThrottleOptions';

export default class NotificationThrottleEdit extends React.PureComponent {
  render() {
    const {value, period, setDamping} = this.props;

    return (
      <div className="notification-throttle-edit">
        <span>Combine events within</span>
        <div className="inline-inputs">
          <div className="inputs">
            <InputField type="number" value={value} onChange={v => setDamping(v, period)} />
            <SelectField
              options={throttleOptions}
              value={period}
              onChange={p => setDamping(value, p)}
              hideResetButton
            />
          </div>
        </div>
        <span>of each other</span>
      </div>
    );
  }
}
